<template>
  <div class="tracked-measurements-form-input-groups">
    <template v-for="measurementType in group.MeasurementTypes">
      <component
         v-bind:is="componentName(measurementType.input_type)"
         v-show="componentShow(measurementType.overridable, measurementType.display)"
        :input="measurementType"
        :disabled="!edit"
        :clearable="false"
        :allData="allData"
        :originalData="originalData"
        :percentageValueField="true"
        @set:value="onValueEvent">
      </component>
    </template>
  </div>
</template>

<script>
import GroupAbstract from './group-abstract';

export default {
  mixins: [GroupAbstract],
  name: 'tracked-measurements-form-input-group-percentage-value',
  methods: {
    componentShow(overridable, display) {
      let count = 0;
      if (this.prefferedInputType === 'both' || this.prefferedInputType === display) {
        count += 1;
      }
      return count > 0;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/participant-evolution/measurement/tracked-measurements-form-input-groups/group-percentage-value.vue